// extracted by mini-css-extract-plugin
export default {"badge":"TextBadge_badge__6hpTF","draft":"TextBadge_draft__A0ErA","active":"TextBadge_active__Q5NAj","inactive":"TextBadge_inactive__cvpTW"};